import Vue from 'vue'
import Router from 'vue-router'
import Browse from '@/components/Browse'
import Frame from '@/components/Frame'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/frame/:url',
      name: 'Frame',
      component: Frame,
      props: true
    },
    {
      path: '/browse/*',
      name: 'Browse',
      component: Browse
    },
    {
      path: '/browse',
      name: 'Browse-default',
      component: Browse,
      props: (route) => ({ url: route.query.url })
    },
    {
      path: '*',
      redirect: '/browse'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js